import React, {FC, useEffect, useState} from 'react'
import CreatableSelect from 'react-select/creatable'
import {MultiValue} from 'react-select'
import {searchContacts} from './Api'

export interface IParticipant {
  name: string | null
  email: string
}

type Option = {value: string; label: string; name: string | null}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

type Props = {
  value: IParticipant[]
  onChange: (participants: IParticipant[]) => void
}

/**
 * Katılımcı seçici: rehberde ad / e-posta ile arar; rehberde olmayan e-posta yazılıp
 * eklenebilir (mülakat kaydedilince rehbere de eklenir).
 */
export const ContactPicker: FC<Props> = ({value, onChange}) => {
  const [input, setInput] = useState('')
  const [options, setOptions] = useState<Option[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(true)
      searchContacts(input.trim(), 0, 20)
        .then(({data}) =>
          setOptions(
            data.payload.content.map((contact) => ({
              value: contact.email,
              label: `${contact.name} · ${contact.email}${contact.title ? ` (${contact.title})` : ''}`,
              name: contact.name,
            }))
          )
        )
        .catch(() => setOptions([]))
        .finally(() => setLoading(false))
    }, 300)
    return () => clearTimeout(timer)
  }, [input])

  const selected: Option[] = value.map((participant) => ({
    value: participant.email,
    label: participant.name ? `${participant.name} · ${participant.email}` : participant.email,
    name: participant.name,
  }))

  return (
    <CreatableSelect<Option, true>
      isMulti
      isLoading={loading}
      options={options}
      value={selected}
      inputValue={input}
      onInputChange={(text, meta) => {
        if (meta.action === 'input-change') setInput(text)
        if (meta.action === 'menu-close' || meta.action === 'set-value') setInput('')
      }}
      onChange={(items: MultiValue<Option>) =>
        onChange(items.map((item) => ({name: item.name, email: item.value.trim().toLowerCase()})))
      }
      isValidNewOption={(text) => EMAIL_PATTERN.test(text.trim())}
      formatCreateLabel={(text) => `"${text}" e-postasını ekle`}
      getNewOptionData={(text) => ({value: text.trim().toLowerCase(), label: text.trim().toLowerCase(), name: null})}
      filterOption={() => true}
      placeholder='Rehberden ara ya da e-posta yaz'
      noOptionsMessage={() => 'Rehberde bulunamadı; e-posta adresini yazarak ekleyebilirsiniz'}
      classNamePrefix='react-select'
    />
  )
}
